import { render, staticRenderFns } from "./ModalDeleteActivity.vue?vue&type=template&id=581be3ce&"
import script from "./ModalDeleteActivity.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports